module.exports = __webpack_public_path__ + "static/media/bcause-logo-inline.7c4f1b4e.png";